<template lang="pug">
div
  h2.mb-4 Instellingen

  v-tabs.mt-4(v-model='activeTab', v-if='!$store.getters["organization/isFirstUse"]')
    v-tab(key='organization', :to='{ name: "settings organization" }') Organisatie
    v-tab(key='notifications', :to='{ name: "settings notifications" }') Personalisatie
    v-tab(key='billing', :to='{ name: "settings invoices" }') Facturen
    v-tab(key='users', :to='{ name: "settings users" }') Gebruikers
    v-tab(key='exports', :to='{ name: "settings exports" }') Exporteren

  router-view

</template>

<script>
export default {
  components: {

  },

  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
